<div class="main-content">
  <header class="top-header">
    <h3>{{ isEdit ? 'Edit Technology Partner' : 'Add Technology Partner' }}</h3>
  </header>

  <form class="form" [formGroup]="partnerForm" (ngSubmit)="onSubmit()">
    <div class="form-row">
      <div class="form-group">
        <label for="name">Name (Slug) <small>*</small></label>
        <input
          id="name"
          type="text"
          placeholder="e.g. plate_recognizer"
          formControlName="name"
          (blur)="normalizeName()"
        />
        <small class="helper-text">Use lowercase letters, numbers, and underscores only.</small>
        <div class="error" *ngIf="partnerForm.get('name')?.invalid && partnerForm.get('name')?.touched">
          <small *ngIf="partnerForm.get('name')?.errors?.['required']">Name is required.</small>
          <small *ngIf="partnerForm.get('name')?.errors?.['pattern']">
            Only lowercase letters, numbers, and underscores are allowed.
          </small>
        </div>
      </div>

      <div class="form-group">
        <label for="display_name">Display Name <small>*</small></label>
        <input
          id="display_name"
          type="text"
          placeholder="Display Name"
          formControlName="display_name"
        />
        <div class="error" *ngIf="partnerForm.get('display_name')?.invalid && partnerForm.get('display_name')?.touched">
          <small *ngIf="partnerForm.get('display_name')?.errors?.['required']">Display name is required.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group toggle-field">
        <label for="is_active">Status</label>
        <div class="toggle-input">
          <input id="is_active" type="checkbox" formControlName="is_active" />
          <span>{{ partnerForm.get('is_active')?.value ? 'Active' : 'Inactive' }}</span>
        </div>
      </div>
    </div>

    <div class="button-row">
      <button class="btn-save" type="submit" [disabled]="loading || saving">
        <fa-icon [icon]="['fas', isEdit ? 'pen-to-square' : 'square-plus']" style="padding-right: 3px;"></fa-icon>
        {{ isEdit ? 'UPDATE' : 'ADD' }}
      </button>
      <button class="btn-cancel" type="button" (click)="onCancel()">
        <fa-icon [icon]="['fas', 'square-xmark']" style="padding-right: 3px;"></fa-icon>
        Cancel
      </button>
    </div>
  </form>
</div>
